




























import { Component, Vue } from "vue-property-decorator";
import { otherUserReply } from "@/req/user";
@Component
export default class Logout extends Vue {
  public isloading = true;
  public valueText = 2.5;
  public page = 1;
  public pageSize = 10;
  public list: any = [];
  public data: any = [];
  public dataLength = 0;
  public uid: any = "";

  public mounted() {
    if (this.$route.query.uid) {
      this.uid = this.$route.query.uid;
    }
    this.getList();
  }
  public async getList() {
    this.isloading = false;
    const obj = {
      uid: this.uid,
      page: this.page,
      size: this.pageSize,
    }
    const res = await otherUserReply(obj);
    if (res.code == 200) {
      this.data = res.data;
      this.dataLength = this.data.data.length;
    }
    this.isloading = true;
  }
  public changepage(index) {
    this.page = index;
    this.getList();
  }
}
